/**
 * Created by gusenlin on 2020/08/26.
 */
import ValueListComponent from '@/components/base-ui/base-value-list';
import { mergeOptions } from '../pluginHelper';
import Vue from 'vue';

let $vm;

const plugin = {
  show(options) {
    if (!$vm) {
      const ValueList = Vue.extend(ValueListComponent);
      $vm = new ValueList({
        el: document.createElement('div'),
      });
      document.body.appendChild($vm.$el);
    }

    if (typeof options === 'object') {
      mergeOptions($vm, options);
      $vm.fetchData = options.fetchData;
    }

    $vm.$off('selectValueListEvent');
    $vm.$off('closeValueListEvent');

    $vm.$on('closeValueListEvent', (res) => {
      $vm.currentValue = false;
      options && options.closeValueListEvent && options.closeValueListEvent(res);
    });
    $vm.$on('selectValueListEvent', (res) => {
      $vm.currentValue = false;
      options && options.selectValueListEvent && options.selectValueListEvent(res);
    });

    $vm.currentValue = true;
  },
  close() {
    $vm.currentValue = false;
  },
};

export default plugin;
